import { scale } from '@cloudinary/url-gen/actions/resize'

import {
  AspectRatio,
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
} from '@masterplandev/ui'

import { cloudinary } from '@/cloudinary/cloudinary'
import { MediaPlayer } from '@/core/components/MediaPlayer/MediaPlayer'
import useTranslation from '@/core/hooks/useTranslation'
import { linebreak } from '@/core/richTextElements'

export function AIFoundationIntro({ onContinue }: { onContinue: () => void }) {
  const { translate } = useTranslation('ai-foundations-intro')

  return (
    <div>
      <Container maxW="container.lg">
        <AspectRatio
          ratio={1085 / 410}
          backgroundImage={cloudinary
            .image('system/ai-foundations-intro')
            .resize(scale().height(410).width(1085))
            .quality('auto:eco')
            .format('auto')
            .toURL()}
          backgroundSize="contain">
          <Box pl="23.1%" pr="22.5%" pb="3.8%">
            <MediaPlayer
              src={translate('video')}
              storage={undefined}
              autoPlay
              muted={false}
              playsInline
              style={{ borderRadius: '2%' }}
              loop
            />
          </Box>
        </AspectRatio>
      </Container>
      <VStack spacing="6">
        <Heading size={['h4', 'h3']}>{translate('title')}</Heading>
        <Text
          textAlign="center"
          color="mp2.neutralDark.800"
          size={['default', 'big']}>
          {translate('text', { linebreak })}
        </Text>
        <Button size="lg" onClick={onContinue}>
          {translate('continue')}
        </Button>
      </VStack>
    </div>
  )
}
